export default {
  "fr": {
    "company_structure_type_id_list_102": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filiale d'un groupe étranger"])},
    "company_structure_type_id_list_132": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprise active à l'international"])},
    "company_structure_type_id_list_160": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprise basée à l'étranger"])}
  },
  "en": {
    
  }
}